// Redux
import { ReactNode } from "react";
import Avatar from "@mui/material/Avatar";
import { twMerge } from "tailwind-merge";

// Icons
import { ReactComponent as NoUserIcon } from "@/assets/icons/svg/no_user.svg";
import { ReactComponent as QuestionMarkIcon } from "@/assets/icons/svg/question_mark.svg";

export const UserProfilePicture = (props: { src: string; className: string; iconClasses: string }) => {
	const { src = "", className = "", iconClasses = "" } = props;

	const imageMap: Record<string, ReactNode> = {
		Holder: <NoUserIcon className={twMerge(iconClasses, "mt-[15px]")} />,
		Unknown: <QuestionMarkIcon className={iconClasses} />,
	};

	return (
		<Avatar src={props.src} alt="User Profile" className={className}>
			{imageMap[src]}
		</Avatar>
	);
};
